import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=2d6cb20e&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=2d6cb20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6cb20e",
  null
  
)

export default component.exports